import {useEffect, useState} from "react";
import {clearCartItemForSession, getSystemCart} from "../../api/Api";
import {Link} from "react-router";
import {fixedToDisplayUnit} from "../../util/unitutils";
import {CategoryType, UnitType} from "../../api/Constants";
import {BookStatusTag} from "../inventory/BookStatusTag";
import {Button, Card, Table} from "antd";

export const SystemCart = ({refresh, onRefresh, onApiFail, props}) => {

    const [inventory, setInventory] = useState([]);

    useEffect(() => {
        getSystemCart().then(r => {
            console.log(r);
            setInventory(r.map(row => {
                return {
                    ...row,
                    key: `${row.inventoryId}-${row.userId}`
                }
            }).filter(row => {
                return row.quantity > 0
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
            render: (val, record, index) => {
                return <Link to={`/inventory/${record.id}`}>{val}</Link>
            },
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku',
            sorter: (a, b) => a.sku.toLowerCase().localeCompare(b.sku.toLowerCase()),
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record, index) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                if (record.category === CategoryType.Wholesale) {
                    return `${displayQuantity} ${UnitType.Label[record.unit]}`
                }
                return displayQuantity;
            },
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            render: (val, record, index) => {
                return CategoryType.Label[val]
            },
        },
        {
            title: 'Book',
            dataIndex: 'book',
            key: 'book',
            render: (val, record, index) => {
                return <BookStatusTag book={val} />
            },
        },
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.username.localeCompare(b.username)
        },
        {
            title: 'Return',
            dataIndex: 'inventoryId',
            key: 'return',
            render: (val, record) => {
                return <Button onClick={onClear(record.sessionId, record.inventoryId)}>Return to Inventory</Button>
            }
        }
    ];

    const onClear = (sessionId, inventoryId) => () => {
        console.log(`${sessionId} ${inventoryId}`);
        clearCartItemForSession(sessionId, inventoryId).then(r => {
            console.log(`refresh`)
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const cardStyle = {
        textAlign: 'left'
    }

    return <Card style={cardStyle} title={<b>Reserved Inventory</b>}>
        <div style={{color: 'red', marginTop: '5px', marginBottom: '5px'}}>
            Inventory that has been temporarily reserved by All users.
        </div>
        <div style={{marginTop: '5px', marginBottom: '5px'}}>
            <Table dataSource={inventory} columns={columns} pagination={false}/>
        </div>
    </Card>
}